import { render, staticRenderFns } from "./ROSIER.vue?vue&type=template&id=2ec24a5f&scoped=true&"
import script from "./ROSIER.vue?vue&type=script&lang=js&"
export * from "./ROSIER.vue?vue&type=script&lang=js&"
import style0 from "./ROSIER.vue?vue&type=style&index=0&id=2ec24a5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec24a5f",
  null
  
)

export default component.exports